import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const CART_SAVE_FOR_LATER_URL = `${CART_URL}/save-for-later/line-items`;

export async function addToSaveForLater(
  sku: string
): Promise<{ data: HttpCartDto }> {
  return httpClient.post(CART_SAVE_FOR_LATER_URL, [{ sku }]);
}
